import { LineCheck } from '@qr-front/icons/line-check'
import { LineChevronDownSmall } from '@qr-front/icons/line-chevron-down-small'
import { inputCls } from '@qr-front/ui/components/Input'
import {
	Select,
	SelectContent,
	SelectGroup,
	SelectIcon,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@qr-front/ui/components/Select'
import { cn } from '@qr-front/ui/utils'
import { useTranslations } from 'next-intl'

const downloadActions = [
	{
		key: 'downloadAsSvg',
		translationKey: 'dashboard__qr_table__qr_card__download_option__svg',
	},
	{
		key: 'downloadAsPng',
		translationKey: 'dashboard__qr_table__qr_card__download_option__png',
	},
	{
		key: 'downloadAsJpg',
		translationKey: 'dashboard__qr_table__qr_card__download_option__jpg',
	},
]

export const SelectDownloadType = ({
	type,
	onChange,
}: {
	type: string
	onChange: (value: string) => void
}) => {
	const t = useTranslations()

	return (
		<div className="flex w-full flex-col">
			<span className="type-body-small font-semibold leading-[16px] tracking-tight text-dark-grey">
				{t('dashboard__qr_table__qr_card__download_qr_code_type')}
			</span>
			<Select value={type} onValueChange={onChange}>
				<SelectTrigger
					className={cn(
						inputCls(),
						'group/select type-body-small relative mt-2 h-10 w-full text-left',
					)}
				>
					<SelectValue />
					<SelectIcon className="absolute right-4 top-1/2 -translate-y-1/2">
						<LineChevronDownSmall
							width={16}
							height={16}
							className="text-dark-grey transition-transform duration-300 group-data-[state=closed]/select:rotate-0 group-data-[state=open]/select:rotate-180"
						/>
					</SelectIcon>
				</SelectTrigger>

				<SelectContent
					sideOffset={4}
					position="popper"
					className="z-50 w-[var(--radix-select-trigger-width)]"
				>
					<SelectGroup className="mt-1 w-full rounded-8 border border-solid border-border-grey bg-white p-4">
						{downloadActions.map(({ key, translationKey }) => (
							<SelectItem
								icon={<LineCheck width={16} height={16} />}
								key={key}
								value={key}
								className="focus:text-dark-grey data-[state=checked]:bg-generator-bg data-[state=checked]:text-dark-grey hover:bg-generator-bg hover:text-dark-grey"
							>
								{t(translationKey)}
							</SelectItem>
						))}
					</SelectGroup>
				</SelectContent>
			</Select>
		</div>
	)
}
